(function () {
  'use strict';

  var TR = window.TRIGRRR || {};
  var routes = TR.routes || {};
  var moneyFormat = TR.moneyFormat || '{{amount}}';
  var freeShippingThreshold = TR.freeShippingThreshold || 500;
  var SHIP_COST_CENTS = 4900;

  var cartAddUrl = (routes.cartAdd || '/cart/add') + '.js';
  var cartChangeUrl = (routes.cartChange || '/cart/change') + '.js';
  var cartJsUrl = (routes.cartUrl || '/cart') + '.js';

  /* ============ helpers ============ */

  function formatMoney(cents) {
    cents = Math.round(cents || 0);
    var value2 = (cents / 100).toFixed(2);
    var value0 = Math.round(cents / 100).toString();
    var withComma2 = value2.replace(/\d(?=(\d{3})+\.)/g, '$&,');
    var withComma0 = value0.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/, value2)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, value0)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma2)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, withComma0);
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function effectivePrice(item) {
    if (!item) return 0;
    if (item.price) return item.price;
    if (item.priceFallback) return item.priceFallback * 100;
    return 0;
  }

  var toastEl = document.getElementById('toast');
  var toastTimer;
  function showToast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2600);
  }

  /* ============ product data catalog ============ */

  var CATALOG = {};
  document.querySelectorAll('[data-product-data]').forEach(function (el) {
    var data;
    try { data = JSON.parse(el.textContent); } catch (e) { return; }
    var id = data.id;
    if (!id) return;
    if (!CATALOG[id]) CATALOG[id] = { id: id };
    Object.keys(data).forEach(function (key) {
      var val = data[key];
      var truthy = val !== '' && val !== null && val !== undefined && val !== 0 && val !== false;
      if (truthy || !(key in CATALOG[id])) CATALOG[id][key] = val;
    });
  });

  /* ============ cart (real Shopify Ajax Cart API) ============ */

  function cartAdd(items) {
    return fetch(cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json(); });
  }

  function cartChange(line, quantity) {
    return fetch(cartChangeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  function fetchCart() {
    return fetch(cartJsUrl, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  var stashDrawer = document.getElementById('stashDrawer');
  var cartScrim = document.getElementById('cartScrim');
  var stashFab = document.getElementById('stashFab');
  var stashFabCount = document.getElementById('stashFabCount');
  var stashCountEl = document.getElementById('stashCount');
  var stashBody = document.getElementById('stashBody');
  var stashFoot = document.getElementById('stashFoot');

  function openDrawer() {
    if (stashDrawer) stashDrawer.classList.add('is-open');
    if (cartScrim) cartScrim.classList.add('is-open');
    if (stashFab) stashFab.classList.add('is-hidden');
  }
  function closeDrawer() {
    if (stashDrawer) stashDrawer.classList.remove('is-open');
    if (cartScrim) cartScrim.classList.remove('is-open');
    if (stashFab) stashFab.classList.remove('is-hidden');
  }

  function tierPct(boxQty) {
    if (boxQty >= 4) return 15;
    if (boxQty === 3) return 10;
    if (boxQty === 2) return 5;
    return 0;
  }

  function renderCart(cart) {
    if (!stashBody) return;
    var count = cart.item_count || 0;
    if (stashCountEl) stashCountEl.textContent = count;
    if (stashFabCount) stashFabCount.textContent = count;
    if (stashFab) stashFab.classList.toggle('is-visible', count > 0);

    if (count === 0) {
      stashBody.innerHTML = '<div class="stash-drawer__empty">nothing in here yet. the collection is a scroll away.</div>';
      if (stashFoot) stashFoot.style.display = 'none';
      var shipNoteEmpty = document.getElementById('shipNote');
      if (shipNoteEmpty) shipNoteEmpty.textContent = '';
      var shipFillEmpty = document.getElementById('shipBarFill');
      if (shipFillEmpty) shipFillEmpty.style.width = '0%';
      return;
    }

    var rowsHtml = cart.items.map(function (item, idx) {
      return (
        '<div class="stash-drawer__row">' +
          '<img src="' + escapeHtml(item.image || '') + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">' +
          '<div style="flex:1;min-width:110px;">' +
            '<div class="stash-drawer__row-name">' + escapeHtml(item.product_title) + '</div>' +
            '<div class="stash-drawer__row-sub">' + escapeHtml(item.variant_title || '') + '</div>' +
          '</div>' +
          '<div class="stash-drawer__row-stepper">' +
            '<button type="button" class="stash-drawer__row-step-btn" data-cart-dec data-line="' + (idx + 1) + '" data-line-qty="' + item.quantity + '" aria-label="Decrease quantity">−</button>' +
            '<div class="stash-drawer__row-qty">' + item.quantity + '</div>' +
            '<button type="button" class="stash-drawer__row-step-btn stash-drawer__row-step-btn--inc" data-cart-inc data-line="' + (idx + 1) + '" data-line-qty="' + item.quantity + '" aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<div class="stash-drawer__row-line">' + formatMoney(item.line_price) + '</div>' +
        '</div>'
      );
    }).join('');
    stashBody.innerHTML = rowsHtml;
    if (stashFoot) stashFoot.style.display = '';

    var pct = tierPct(cart.item_count);
    var subtotal = cart.total_price;
    var discount = Math.round(subtotal * pct / 100);
    var total = subtotal - discount;
    var shipFree = subtotal >= freeShippingThreshold * 100;
    var shipCost = shipFree ? 0 : SHIP_COST_CENTS;
    var grand = total + shipCost;

    setText('stashSubtotal', formatMoney(subtotal));
    var discountRow = document.getElementById('stashDiscountRow');
    if (discountRow) {
      if (pct > 0) {
        discountRow.style.display = '';
        setText('stashDiscountLabel', 'MULTI-BOX −' + pct + '%');
        setText('stashDiscountVal', '−' + formatMoney(discount));
      } else {
        discountRow.style.display = 'none';
      }
    }
    setText('stashShipLine', shipFree ? 'FREE' : formatMoney(SHIP_COST_CENTS));
    setText('stashTotal', formatMoney(grand));

    var shipNote = document.getElementById('shipNote');
    if (shipNote) {
      shipNote.textContent = shipFree
        ? 'free shipping unlocked ✓'
        : formatMoney(Math.max(0, (freeShippingThreshold * 100) - subtotal)) + ' away from free shipping (over ' + formatMoney(freeShippingThreshold * 100) + ')';
    }
    var shipFill = document.getElementById('shipBarFill');
    if (shipFill) shipFill.style.width = Math.min(100, Math.round((subtotal / (freeShippingThreshold * 100)) * 100)) + '%';
  }

  function setText(id, text) {
    var el = document.getElementById(id);
    if (el) el.textContent = text;
  }

  function addToCart(items) {
    return cartAdd(items).then(function (res) {
      if (res && res.status) {
        showToast(res.description || 'That could not be added to your stash.');
        return fetchCart().then(renderCart);
      }
      return fetchCart().then(function (cart) {
        renderCart(cart);
        openDrawer();
        return cart;
      });
    }).catch(function () {
      showToast('Something went wrong — please try again.');
    });
  }

  document.getElementById('stashBtn') && document.getElementById('stashBtn').addEventListener('click', openDrawer);
  stashFab && stashFab.addEventListener('click', openDrawer);
  document.getElementById('stashClose') && document.getElementById('stashClose').addEventListener('click', closeDrawer);
  cartScrim && cartScrim.addEventListener('click', closeDrawer);

  stashBody && stashBody.addEventListener('click', function (e) {
    var incBtn = e.target.closest('[data-cart-inc]');
    var decBtn = e.target.closest('[data-cart-dec]');
    var btn = incBtn || decBtn;
    if (!btn) return;
    var line = parseInt(btn.getAttribute('data-line'), 10);
    var qty = parseInt(btn.getAttribute('data-line-qty'), 10) + (incBtn ? 1 : -1);
    cartChange(line, Math.max(0, qty)).then(renderCart);
  });

  document.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var flavor = btn.getAttribute('data-flavor');
      var item = CATALOG[flavor];
      if (!item || !item.variantId) return;
      addToCart([{ id: item.variantId, quantity: 1 }]);
    });
  });

  /* ============ product buy box (qty stepper + direct add-to-cart) ============ */

  document.querySelectorAll('[data-buybox-add]').forEach(function (btn) {
    var wrap = btn.closest('.product-buybox__info') || document;
    var qtyEl = wrap.querySelector('[data-buybox-qty]');
    var decBtn = wrap.querySelector('[data-buybox-dec]');
    var incBtn = wrap.querySelector('[data-buybox-inc]');
    var qty = 1;

    function renderQty() { if (qtyEl) qtyEl.textContent = qty; }

    decBtn && decBtn.addEventListener('click', function () { qty = Math.max(1, qty - 1); renderQty(); });
    incBtn && incBtn.addEventListener('click', function () { qty = Math.min(20, qty + 1); renderQty(); });

    btn.addEventListener('click', function () {
      var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
      if (!variantId) return;
      addToCart([{ id: variantId, quantity: qty }]);
    });
  });

  /* ============ product page gallery thumbnails ============ */

  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    var stage = gallery.querySelector('.product-gallery__stage');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (main) main.src = thumb.getAttribute('data-src');
        if (stage) stage.classList.toggle('is-contain', thumb.getAttribute('data-fit') === 'contain');
      });
    });
  });

  fetchCart().then(renderCart).catch(function () {});

  /* ============ mobile nav ============ */

  var burger = document.getElementById('navBurger');
  var mobileMenu = document.getElementById('mobileMenu');
  if (burger && mobileMenu) {
    burger.addEventListener('click', function () {
      var isOpen = mobileMenu.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
    document.addEventListener('click', function (e) {
      if (mobileMenu.classList.contains('is-open') && !mobileMenu.contains(e.target) && e.target !== burger && !burger.contains(e.target)) {
        mobileMenu.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
      }
    });
    mobileMenu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { mobileMenu.classList.remove('is-open'); });
    });
  }

  /* ============ hero: photo stack, SKU picker, peelable note ============ */

  var heroSection = document.querySelector('[data-hero]');
  if (heroSection) {
    var defaultSku = heroSection.getAttribute('data-default-sku') || 'yellow';
    var autoPeelSeconds = parseFloat(heroSection.getAttribute('data-auto-peel-seconds') || '3');
    var photos = Array.prototype.slice.call(heroSection.querySelectorAll('[data-hero-photo]'));
    var allFlavors = photos.map(function (img) { return img.getAttribute('data-flavor'); });
    var order = [defaultSku].concat(allFlavors.filter(function (f) { return f !== defaultSku; }));
    var peeled = {};
    var notePhase = 'attached';
    var looseTimer = null;
    var noteTimers = [];

    var heroFrame = document.getElementById('heroFrame');
    var heroNote = document.getElementById('heroNote');
    var heroNoteText = document.getElementById('heroNoteText');
    var heroPeelHint = document.getElementById('heroPeelHint');

    var STACK_POS = [
      { x: 0, y: 0, r: 1.4, z: 110 },
      { x: 18, y: 14, r: -4, z: 80 },
      { x: 32, y: 26, r: 6, z: 60 },
      { x: 44, y: 38, r: -8, z: 40 }
    ];

    function layoutPhotos() {
      photos.forEach(function (img) {
        var flavor = img.getAttribute('data-flavor');
        var idx = order.indexOf(flavor);
        var pos = STACK_POS[idx] || STACK_POS[STACK_POS.length - 1];
        img.style.transform = 'translate(' + pos.x + 'px,' + pos.y + 'px) rotate(' + pos.r + 'deg)';
        img.style.zIndex = pos.z;
        img.style.filter = 'drop-shadow(0 ' + (16 + idx * 4) + 'px ' + (22 + idx * 5) + 'px rgba(40,28,12,' + (0.36 - idx * 0.05).toFixed(2) + '))';
      });
    }

    function setNotePhase(phase) {
      notePhase = phase;
      heroNote.classList.remove('is-loose', 'is-lift', 'is-detach', 'is-fall', 'is-gone');
      if (phase !== 'attached') heroNote.classList.add('is-' + phase);
      if (heroPeelHint) heroPeelHint.classList.toggle('is-hidden', phase !== 'attached');
    }

    function scheduleLoosen() {
      clearTimeout(looseTimer);
      if (autoPeelSeconds <= 0) return;
      looseTimer = setTimeout(function () {
        if (notePhase === 'attached') setNotePhase('loose');
      }, autoPeelSeconds * 1000);
    }

    function finishPeel() {
      peeled[order[0]] = true;
      setNotePhase('gone');
    }

    function peelNote() {
      if (notePhase !== 'attached' && notePhase !== 'loose') return;
      noteTimers.forEach(clearTimeout);
      clearTimeout(looseTimer);
      if (notePhase === 'loose') {
        setNotePhase('detach');
        noteTimers[0] = setTimeout(function () { setNotePhase('fall'); }, 230);
        noteTimers[1] = setTimeout(finishPeel, 1190);
      } else {
        setNotePhase('lift');
        noteTimers[0] = setTimeout(function () { setNotePhase('detach'); }, 190);
        noteTimers[1] = setTimeout(function () { setNotePhase('fall'); }, 420);
        noteTimers[2] = setTimeout(finishPeel, 1380);
      }
    }

    function updateNote() {
      var flavor = order[0];
      var item = CATALOG[flavor];
      if (heroNoteText) heroNoteText.textContent = (item && item.note) || '';
      clearTimeout(looseTimer);
      if (peeled[flavor]) {
        setNotePhase('gone');
      } else {
        setNotePhase('attached');
        if (flavor === defaultSku) scheduleLoosen();
      }
    }

    function pick(flavor) {
      if (flavor === order[0]) return;
      order = [flavor].concat(order.filter(function (f) { return f !== flavor; }));
      layoutPhotos();
      document.querySelectorAll('[data-sku-btn]').forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-flavor') === flavor);
      });
      updateNote();
    }

    document.querySelectorAll('[data-sku-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () { pick(btn.getAttribute('data-flavor')); });
    });
    heroNote && heroNote.addEventListener('click', function (e) {
      e.stopPropagation();
      peelNote();
    });
    heroFrame && heroFrame.addEventListener('click', function (e) {
      if (heroNote && heroNote.contains(e.target)) return;
      var idx = allFlavors.indexOf(order[0]);
      var next = allFlavors[(idx + 1) % allFlavors.length];
      if (next) pick(next);
    });

    layoutPhotos();
    updateNote();
  }

  /* ============ ingredient tabs ============ */

  document.querySelectorAll('[data-ingredient-widget]').forEach(function (widget) {
    var tabs = Array.prototype.slice.call(widget.querySelectorAll('[data-ingredient-tab]'));
    var panels = Array.prototype.slice.call(widget.querySelectorAll('[data-ingredient-panel]'));
    var frame = widget.querySelector('[data-ingredient-frame]');

    function activate(index, focusTab) {
      tabs.forEach(function (tab, i) {
        var active = i === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
      });
      panels.forEach(function (panel, i) {
        var active = i === index;
        panel.classList.toggle('is-active', active);
        if (active) { panel.removeAttribute('hidden'); } else { panel.setAttribute('hidden', ''); }
      });
      if (frame) {
        var color = tabs[index].getAttribute('data-color');
        if (color) frame.style.borderColor = color;
      }
      if (focusTab) tabs[index].focus();
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { activate(i, false); });
      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight') next = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = tabs.length - 1;
        if (next !== null) { e.preventDefault(); activate(next, true); }
      });
    });
  });

  /* ============ ingredient photo carousel ============ */

  document.querySelectorAll('[data-ingredient-carousel]').forEach(function (carousel) {
    var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-carousel-slide]'));
    var nextBtn = carousel.querySelector('[data-carousel-next]');
    var current = 0;
    var timer = null;

    function show(index) {
      current = index;
      slides.forEach(function (slide, i) { slide.classList.toggle('is-active', i === current); });
    }

    function advance() { show((current + 1) % slides.length); }

    function startTimer() {
      if (timer) clearInterval(timer);
      timer = setInterval(advance, 5000);
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        advance();
        startTimer();
      });
    }

    startTimer();
  });

  /* ============ comparison sliders ============ */

  document.querySelectorAll('[data-comparison-slider]').forEach(function (el) {
    var clip = el.querySelector('[data-comparison-clip]');
    var handle = el.querySelector('[data-comparison-handle]');
    var grip = el.querySelector('[data-comparison-grip]');
    var dragging = false;

    function update(clientX) {
      var rect = el.getBoundingClientRect();
      var pct = ((clientX - rect.left) / rect.width) * 100;
      pct = Math.max(6, Math.min(94, pct));
      clip.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      handle.style.left = pct + '%';
      grip.style.left = pct + '%';
    }

    el.addEventListener('pointerdown', function (e) {
      dragging = true;
      try { el.setPointerCapture(e.pointerId); } catch (err) {}
      update(e.clientX);
    });
    el.addEventListener('pointermove', function (e) {
      if (dragging && (e.buttons & 1)) update(e.clientX);
    });
    el.addEventListener('pointerup', function () { dragging = false; });
    el.addEventListener('pointercancel', function () { dragging = false; });
  });

  /* ============ sticky notes (click to fall away) ============ */

  document.querySelectorAll('[data-sticky-note]').forEach(function (note) {
    function fall() {
      if (note.classList.contains('is-fall')) return;
      note.classList.add('is-fall');
      setTimeout(function () { note.classList.add('is-gone'); }, 850);
    }
    note.addEventListener('click', fall);
    note.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); fall(); }
    });
  });

  /* ============ FAQ accordion ============ */

  document.querySelectorAll('[data-faq-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('[data-faq-item]');
      var list = item.parentElement;
      var wasOpen = item.classList.contains('is-open');
      list.querySelectorAll('[data-faq-item]').forEach(function (other) {
        other.classList.remove('is-open');
        var otherToggle = other.querySelector('[data-faq-toggle]');
        var otherSym = other.querySelector('[data-faq-sym]');
        if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
        if (otherSym) otherSym.textContent = '+';
      });
      if (!wasOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        var sym = item.querySelector('[data-faq-sym]');
        if (sym) sym.textContent = '−';
      }
    });
  });

  /* ============ spec sheet lightbox ============ */

  var specSheet = document.getElementById('specSheet');
  var specSheetImg = document.getElementById('specSheetImg');
  document.querySelectorAll('[data-open-sheet]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (specSheetImg) specSheetImg.src = btn.getAttribute('data-sheet-src') || '';
      if (specSheet) specSheet.classList.add('is-open');
    });
  });
  specSheet && specSheet.addEventListener('click', function () {
    specSheet.classList.remove('is-open');
    if (specSheetImg) specSheetImg.src = '';
  });

  /* ============ unbox window (scroll-scrubbed film) ============ */

  var unboxWindow = document.getElementById('unboxWindow');
  var unboxScrim = document.getElementById('unboxScrim');
  var unboxClose = document.getElementById('unboxClose');
  var unboxName = document.getElementById('unboxName');
  var unboxScroll = document.getElementById('unboxScroll');
  var unboxFrame = document.getElementById('unboxFrame');
  var unboxReveal = document.getElementById('unboxReveal');
  var unboxProgressFill = document.getElementById('unboxProgressFill');
  var unboxProgressPct = document.getElementById('unboxProgressPct');
  var unboxHint = document.getElementById('unboxHint');
  var unboxProgressBar = document.getElementById('unboxProgressBar');
  var unboxPending = document.getElementById('unboxPending');
  var unboxPendingCard = document.getElementById('unboxPendingCard');
  var unboxAdd = document.getElementById('unboxAdd');
  var currentUnboxFlavor = null;
  var preloadedFlavors = {};

  function setUnboxFrame(item, progress) {
    var idx = Math.max(1, Math.min(item.unboxCount, Math.round(progress * (item.unboxCount - 1)) + 1));
    var padded = String(idx).padStart(4, '0');
    unboxFrame.src = item.unboxFrame1Url.replace('0001.webp', padded + '.webp');
  }

  function preloadUnboxFrames(item) {
    if (preloadedFlavors[item.id] || !item.unboxFrame1Url) return;
    preloadedFlavors[item.id] = true;
    for (var i = 2; i <= item.unboxCount; i++) {
      var img = new Image();
      img.src = item.unboxFrame1Url.replace('0001.webp', String(i).padStart(4, '0') + '.webp');
    }
  }

  function openUnbox(flavor) {
    var item = CATALOG[flavor];
    if (!item || !unboxWindow) return;
    currentUnboxFlavor = flavor;
    if (unboxName) unboxName.textContent = item.name || '';

    if (item.unboxCount > 0 && item.unboxFrame1Url) {
      if (unboxScroll) { unboxScroll.style.display = ''; unboxScroll.scrollTop = 0; }
      if (unboxProgressBar) unboxProgressBar.style.display = '';
      if (unboxPending) unboxPending.style.display = 'none';
      setUnboxFrame(item, 0);
      if (unboxReveal) unboxReveal.classList.remove('is-visible');
      if (unboxHint) unboxHint.style.opacity = '.75';
      if (unboxProgressFill) unboxProgressFill.style.width = '0%';
      if (unboxProgressPct) unboxProgressPct.textContent = '0%';
      preloadUnboxFrames(item);
    } else {
      if (unboxScroll) unboxScroll.style.display = 'none';
      if (unboxProgressBar) unboxProgressBar.style.display = 'none';
      if (unboxPending) unboxPending.style.display = '';
      if (unboxPendingCard) {
        unboxPendingCard.src = item.cardImg || '';
        unboxPendingCard.alt = item.name || '';
      }
    }
    unboxWindow.classList.add('is-open');
  }

  function closeUnbox() {
    if (unboxWindow) unboxWindow.classList.remove('is-open');
    currentUnboxFlavor = null;
  }

  document.querySelectorAll('[data-open-unbox]').forEach(function (btn) {
    btn.addEventListener('click', function () { openUnbox(btn.getAttribute('data-flavor')); });
  });
  unboxClose && unboxClose.addEventListener('click', closeUnbox);
  unboxScrim && unboxScrim.addEventListener('click', closeUnbox);
  unboxScroll && unboxScroll.addEventListener('scroll', function () {
    var item = CATALOG[currentUnboxFlavor];
    if (!item || !(item.unboxCount > 0)) return;
    var max = unboxScroll.scrollHeight - unboxScroll.clientHeight;
    var progress = max > 0 ? unboxScroll.scrollTop / max : 0;
    setUnboxFrame(item, progress);
    var pct = Math.round(progress * 100);
    if (unboxProgressFill) unboxProgressFill.style.width = pct + '%';
    if (unboxProgressPct) unboxProgressPct.textContent = pct + '%';
    var revealed = progress > 0.92;
    if (unboxReveal) unboxReveal.classList.toggle('is-visible', revealed);
    if (unboxHint) unboxHint.style.opacity = revealed ? '0' : '.75';
  });
  unboxAdd && unboxAdd.addEventListener('click', function () {
    var item = CATALOG[currentUnboxFlavor];
    if (item && item.variantId) addToCart([{ id: item.variantId, quantity: 1 }]);
    closeUnbox();
  });

  /* ============ build your own box ============ */

  var boxSection = document.querySelector('[data-build-box]');
  if (boxSection) {
    var boxThreshold = parseFloat(boxSection.getAttribute('data-free-shipping-threshold') || freeShippingThreshold);
    var boxQty = {};
    boxSection.querySelectorAll('[data-box-row]').forEach(function (row) {
      boxQty[row.getAttribute('data-flavor')] = 0;
    });

    var BOX_HINTS = [
      'add two boxes to start saving →',
      'one more box unlocks 5% off',
      'a third box makes it 10%',
      'a fourth box takes it to 15%',
      'maximum good achieved. 15% off.'
    ];

    function renderBox() {
      var flavors = Object.keys(boxQty);
      var totalQty = flavors.reduce(function (sum, f) { return sum + boxQty[f]; }, 0);
      var subtotal = flavors.reduce(function (sum, f) {
        return sum + boxQty[f] * effectivePrice(CATALOG[f]);
      }, 0);
      var pct = tierPct(totalQty);
      var discount = Math.round(subtotal * pct / 100);
      var total = subtotal - discount;
      var shipFree = subtotal > 0 && subtotal >= boxThreshold * 100;
      var shipCost = subtotal === 0 ? 0 : (shipFree ? 0 : SHIP_COST_CENTS);
      var grand = total + shipCost;
      var activeTier = totalQty >= 4 ? 4 : totalQty === 3 ? 3 : totalQty === 2 ? 2 : 0;

      flavors.forEach(function (f) {
        var qtyEl = boxSection.querySelector('[data-box-qty][data-flavor="' + f + '"]');
        if (qtyEl) qtyEl.textContent = boxQty[f];
      });

      var TIER_STEPS = [0, 2, 3, 4];
      var stopIndex = TIER_STEPS.indexOf(activeTier);
      boxSection.querySelectorAll('[data-tier]').forEach(function (t) {
        var tierVal = parseInt(t.getAttribute('data-tier'), 10);
        t.classList.toggle('is-reached', totalQty >= tierVal);
        t.classList.toggle('is-active', tierVal === activeTier);
      });
      var meterFill = document.getElementById('boxMeterFill');
      if (meterFill) meterFill.style.width = (stopIndex / (TIER_STEPS.length - 1) * 100) + '%';

      var linesEl = document.getElementById('orderSlipLines');
      if (linesEl) {
        var picked = flavors.filter(function (f) { return boxQty[f] > 0; });
        if (picked.length === 0) {
          linesEl.innerHTML = '<div class="order-slip__empty">nothing picked yet.</div>';
        } else {
          linesEl.innerHTML = picked.map(function (f) {
            var item = CATALOG[f] || {};
            return '<div class="order-slip__line"><span>' + boxQty[f] + ' × ' + escapeHtml(item.name || f) + '</span><span>' + formatMoney(boxQty[f] * effectivePrice(item)) + '</span></div>';
          }).join('');
        }
      }

      setText('boxSubtotal', formatMoney(subtotal));
      var discountRow = document.getElementById('boxDiscountRow');
      if (discountRow) {
        if (pct > 0) {
          discountRow.style.display = '';
          setText('boxDiscountLabel', 'MULTI-BOX −' + pct + '%');
          setText('boxDiscountVal', '−' + formatMoney(discount));
        } else {
          discountRow.style.display = 'none';
        }
      }
      setText('boxShipLine', subtotal === 0 ? '—' : (shipFree ? 'FREE' : formatMoney(SHIP_COST_CENTS)));
      setText('boxGrand', formatMoney(grand));
      setText('boxHint', BOX_HINTS[Math.min(totalQty, 4)]);
      setText('boxShipNote', subtotal === 0 ? '' : shipFree
        ? 'free shipping unlocked ✓'
        : formatMoney(Math.max(0, (boxThreshold * 100) - subtotal)) + ' away from free shipping (over ' + formatMoney(boxThreshold * 100) + ')');
    }

    boxSection.querySelectorAll('[data-box-inc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var f = btn.getAttribute('data-flavor');
        boxQty[f] = (boxQty[f] || 0) + 1;
        renderBox();
      });
    });
    boxSection.querySelectorAll('[data-box-dec]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var f = btn.getAttribute('data-flavor');
        boxQty[f] = Math.max(0, (boxQty[f] || 0) - 1);
        renderBox();
      });
    });

    var boxSubmit = document.getElementById('boxSubmit');
    boxSubmit && boxSubmit.addEventListener('click', function () {
      var msgEl = document.getElementById('boxMsg');
      var totalQty = Object.keys(boxQty).reduce(function (s, f) { return s + boxQty[f]; }, 0);
      if (totalQty === 0) {
        if (msgEl) msgEl.textContent = 'the box is empty. pick something good first.';
        return;
      }
      var items = Object.keys(boxQty)
        .filter(function (f) { return boxQty[f] > 0; })
        .map(function (f) { return { id: (CATALOG[f] || {}).variantId, quantity: boxQty[f] }; })
        .filter(function (i) { return i.id; });
      if (items.length === 0) {
        if (msgEl) msgEl.textContent = "those flavours aren't linked to a product yet.";
        return;
      }
      addToCart(items).then(function () {
        if (msgEl) msgEl.textContent = 'noted. ' + totalQty + ' packs waiting in your stash.';
      });
    });

    renderBox();
  }
})();
